// extracted by mini-css-extract-plugin
export var columnList = "_ch-0";